import React from "react";
import { Alert, Button, Group, Modal, Table, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconAlertCircle } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { MultiAccountDevices } from "types/analyticsTypes";

interface MultiAccountDevicesNoticeProps {
  data: MultiAccountDevices | null;
}

const MultiAccountDevicesNotice: React.FC<MultiAccountDevicesNoticeProps> = ({ data }) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);

  if (!data || data.count === 0) return null;

  return (
    <>
      <Alert
        mt="md"
        variant="light"
        color="orange"
        icon={<IconAlertCircle size={18} />}
        data-testid="multi-account-devices-notice"
      >
        <Group justify="space-between" wrap="wrap" gap="sm">
          <Text size="sm">{t("analytics.multiAccount.summary", { count: data.count })}</Text>
          <Button size="compact-sm" variant="light" color="orange" onClick={open}>
            {t("analytics.multiAccount.viewDetails")}
          </Button>
        </Group>
      </Alert>
      <Modal
        opened={opened}
        onClose={close}
        title={t("analytics.multiAccount.modalTitle")}
        size="lg"
      >
        <Table.ScrollContainer minWidth={420} maxHeight={480}>
          <Table withRowBorders>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>{t("analytics.multiAccount.serialNumber")}</Table.Th>
                <Table.Th>{t("analytics.multiAccount.accounts")}</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data.devices.map((device) => (
                <Table.Tr key={device.serialNo}>
                  <Table.Td fw={600}>{device.serialNo}</Table.Td>
                  <Table.Td>
                    {device.accounts.map((account) => (
                      <Text key={account.orgId} size="sm">
                        {account.orgName}{" "}
                        <Text span size="xs" c="dimmed">
                          ({account.orgId})
                        </Text>
                        {account.alias && (
                          <Text span size="xs" fs="italic">
                            {" "}
                            – {account.alias}
                          </Text>
                        )}
                      </Text>
                    ))}
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Modal>
    </>
  );
};

export default MultiAccountDevicesNotice;
